import React from "react";
import { AbsoluteFill, Sequence } from "remotion";
import { SfxContext } from "../b2b/ui/Sfx";
import { B2C_SCENES } from "../b2c/B2CVideo";
import { COPY, CopyContext, type Lang } from "../b2c/copy";
import { LOOK } from "../b2c/look";
import { StageFrame } from "../b2c/stage";
import { B2C_FPS, beatFrame, SCENE_BEATS, type SceneKey } from "../b2c/timing";

export type ReelProps = { lang: Lang; scenes: readonly SceneKey[] };

/**
 * Cut frames of a reel: same beat grid as the B2C video, so a reel keeps
 * each scene's length (scenes time their animations to it).
 */
export const reelTimeline = (scenes: readonly SceneKey[]) => {
  let beats = 0;
  const cuts = scenes.map((key) => {
    const from = beats === 0 ? 0 : beatFrame(beats);
    beats += SCENE_BEATS[key];
    return { key, from, frames: beatFrame(beats) - from };
  });
  return { cuts, duration: beatFrame(beats) };
};

/**
 * Instagram reel for Frak's own account (9:16, silent: a trending sound is
 * added in the app). A short cut of B2C scenes, picked in `reels/catalog.ts`.
 */
export const ReelVideo: React.FC<ReelProps> = ({ lang, scenes }) => (
  <CopyContext.Provider value={COPY[lang]}>
    <SfxContext.Provider value={false}>
      <AbsoluteFill style={{ background: LOOK.sky }}>
        <StageFrame format="portrait">
          {reelTimeline(scenes).cuts.map(({ key, from, frames }) => {
            const Scene = B2C_SCENES[key];
            return (
              <Sequence
                key={key}
                name={key}
                from={from}
                durationInFrames={frames}
                premountFor={B2C_FPS}
              >
                <Scene />
              </Sequence>
            );
          })}
        </StageFrame>
      </AbsoluteFill>
    </SfxContext.Provider>
  </CopyContext.Provider>
);
